import { FC } from "react";

export const TableOrderByArrowUp: FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <mask
        id="mask0_3682_357"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3682_357)">
        <path d="M7 14L12 9L17 14H7Z" fill="white" fillOpacity="0.5" />
      </g>
    </svg>
  );
};
